const common = {
    /* 星期 */
    week: {
        MONDAY: 1,
        TUESDAY: 2,
        WEDNESDAY: 3,
        THURSDAY: 4,
        FRIDAY: 5,
        SATURDAY: 6,
        SUNDAY: 0
    },
    /* 报警时间方式 */
    timeMode: {
        ALL_TIME: '0',
        DATE_MODE: '1',
        WEEK_MODE: '2'
    },
    subscribeGroupType: {
        ALARM_TYPE: 1
    }
};
export default common;
